export const TOP_FAVORITES = 5;
// 5 foto dengan suka terbanyak (hanya yang minimal punya 1 suka). Seri: yang lebih baru di atas.
export const topFavorites = (photos) =>
  photos
    .filter((p) => p.likes > 0)
    .sort((a, b) => b.likes - a.likes || b.at - a.at)
    .slice(0, TOP_FAVORITES);
